import React, { useEffect, useState } from "react";
import { FetchData, FetchDataGet } from "../services/FetchData";

import "bootstrap/dist/css/bootstrap.min.css";
import aakhorLogo from "../AppComponents/LoginComponent/static/logo.png";
import { Link, Redirect } from "react-router-dom";
import { getIndexArray } from "../AppClass";

function KeyboardGame() {
  const [data_set, set_data_set] = useState("");

  const [currentIndex, setCurrentIndex] = useState(0);
  const [wordsArray, setwordsArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typed_words, setTypedWords] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [error, setError] = useState(false);
  const [submitted_words, setSubmittedWords] = useState("");

  const [redirect, setRedirect] = useState(false);

  let starting_word_index = localStorage.getItem("startingWordIndex");
  if (starting_word_index === "" || starting_word_index === null) {
    starting_word_index = 0;
  }

  const [startingWordIndex, setStartingWordIndex] = useState(
    starting_word_index
  );

  window.onbeforeunload = function() {
    return "Close window?";
  };

  useEffect(() => {
    if (
      localStorage !== null &&
      localStorage.getItem("user_status") !== "logged_in"
    ) {
      setRedirect(true);
    } else {
      getWords();
    }
  }, []);

  useEffect(() => {
    getWords();
  }, [startingWordIndex]);

  function getWords() {
    setLoading(true);
    //console.log("getWords() = ", startingWordIndex);

    if (data_set === "typed_words") {
      FetchData("/get_typed_words", {
        id: localStorage.getItem("auth_token"),
        startingWordIndex: startingWordIndex
      })
        .then(result => {
          let resJson = JSON.parse(JSON.stringify(result));
          setwordsArray(getIndexArray(resJson, 2));

          setLoading(false);
          setCurrentIndex(0);
          setTypedWords(getIndexArray(resJson, 3));
          setUserInput(getIndexArray(resJson, 3)[0]);
          setError(false);
        })
        .catch(error => {
          setLoading(false);
        });
    } else {
      FetchData("/get_typing_words", {
        id: localStorage.getItem("auth_token"),
        startingWordIndex: startingWordIndex
      })
        .then(result => {
          let resJson = JSON.parse(JSON.stringify(result));
          setwordsArray(resJson);

          setLoading(false);
          setCurrentIndex(0);
          setTypedWords([]);
          setUserInput("");
          setError(false);
        })
        .catch(error => {
          setLoading(false);
        });
    }
  }

  function inputValidation() {
    const typed_text = userInput;

    const regex = /\w+/gim;
    let m;

    let no_of_words = 0;

    while ((m = regex.exec(typed_text)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        //console.log(`Found match, group ${groupIndex}: ${match}`);
      });

      no_of_words++;
    }

    if (no_of_words < 2 && typed_text.length > 0) {
      setError(true);
      return false;
    }
    return true;
  }

  function nextValidation() {
    document.getElementById("type-area").focus();

    if (currentIndex >= wordsArray.length - 1) return;

    if (!inputValidation()) {
      return;
    }

    let nextIndex = currentIndex + 1;
    setCurrentIndex(nextIndex);

    if (typed_words[nextIndex] && typed_words[nextIndex] !== "") {
      setUserInput(typed_words[nextIndex]);
    } else {
      setUserInput("");
    }

    setError(false);
  }

  function goToPrevious() {
    document.getElementById("type-area").focus();

    if (currentIndex < 1) return;

    if (!inputValidation()) {
      return;
    }

    let previousIndex = currentIndex - 1;
    setCurrentIndex(previousIndex);

    if (typed_words[previousIndex] && typed_words[previousIndex] !== "") {
      setUserInput(typed_words[previousIndex]);
    } else {
      setUserInput("");
    }

    setError(false);
  }

  function firstWord(string) {
    let string_splits = string.split(" ");
    if (string_splits.length > 0) {
      return string_splits[0];
    } else {
      return string;
    }
  }

  function filterTypedWords(string) {
    const typed_text = string;

    const regex = /\w+/gim;
    let m;

    let joinedString = "";

    while ((m = regex.exec(typed_text)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      // The result can be accessed through the `m`-variable.
      m.forEach((match, groupIndex) => {
        //console.log(`Found match, group ${groupIndex}: ${match}`);
        joinedString += "," + match.toLowerCase();
      });
    }

    return joinedString.replace(/^,/g, "");
  }

  function submitWords() {
    if (!inputValidation()) {
      return;
    }

    let filteredWordsArray = [];
    let filtered_typed_words = [];

    typed_words.map((value, key) => {
      if (value.length > 0) {
        filteredWordsArray.push(firstWord(wordsArray[key]));
        filtered_typed_words.push(filterTypedWords(value));
      }
    });

    //console.log(filteredWordsArray, filtered_typed_words);
    setLoading(true);
    //return

    FetchData("/submit_typing_words", {
      id: localStorage.getItem("auth_token"),
      word: filteredWordsArray,
      typed_words: filtered_typed_words,
      data_set: data_set
    })
      .then(result => {
        setStartingWordIndex(parseInt(startingWordIndex) + 30);
        localStorage.setItem(
          "startingWordIndex",
          parseInt(startingWordIndex) + 30
        );

        // * get next words
        //getWords();
      })
      .catch(error => {
        setLoading(false);
      });
  }

  function getWordsCount() {
    FetchDataGet(
      "/typed_words_count?id=" + localStorage.getItem("auth_token"),
      {}
    )
      .then(result => {
        setSubmittedWords(result);
      })
      .catch(error => {});
  }

  if (redirect) {
    return <Redirect to={"/"} />;
  }

  return (
    <div>
      {/* <nav className="navbar navbar-light bg-light">
        <a className="navbar-brand" href="/">
          <img
            src={aakhorLogo}
            width="30"
            height="30"
            className="d-inline-block align-top mr-2"
            alt=""
          />
          Aakhor
        </a>
      </nav> */}
      <div className="container mt-4">
        <div className="alert border">
          <Link to={"/"}>
            <span className="navbar-brand p-0">
              <img
                src={aakhorLogo}
                width="30"
                height="30"
                className="d-inline-block align-top"
                alt=""
              />
            </span>
          </Link>
          <strong className="text-primary">Aakhor keyboard game</strong>
          {/* <a href="https://invisionweb.in/" className="float-right">
            <img
              src="https://invisionweb.in/site/static/media/invision.2acab5b0.png"
              width="30"
              height="30"
              alt=""
            />
          </a> */}
          <hr />
          <span>
            Type Assamese equivalent words. For example, write{" "}
            <span className="text-success font-weight-bold">ঘৰ</span> as{" "}
            <strong className="text-danger">ghar</strong>,{" "}
            <strong className="text-danger">ghor</strong> separated by COMMA or
            SPACE.
          </span>
        </div>

        {wordsArray.length > 0 && (
          <div className="text-center">
            <div className="d-flex justify-content-center mt-4">
              <h4 className="bg-light rounded border border-warning py-2 px-3 mb-0">
                {firstWord(wordsArray[currentIndex])}
              </h4>
            </div>
            <span className="badge badge-danger mb-2">
              {currentIndex + 1} / {wordsArray.length}
            </span>
          </div>
        )}

        {wordsArray.length < 1 && !loading && (
          <div className="mb-3 text-center">
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => {
                getWords();
              }}
            >
              Load words
            </button>
          </div>
        )}

        {loading && (
          <div className="text-center my-3">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}

        <div className="form-group">
          <textarea
            className={error ? "form-control is-invalid" : "form-control"}
            id="type-area"
            placeholder="Type here. ghar, ghor, etc"
            rows="2"
            value={userInput}
            //value={typed_words[currentIndex]}
            onChange={e => {
              const typed_value = e.currentTarget.value;
              setUserInput(typed_value);

              let filterArray = typed_words;
              filterArray[currentIndex] = typed_value;

              setTypedWords(filterArray);
            }}
            onKeyUp={e => {
              if (e.keyCode === 13) {
                nextValidation();
              }
            }}
          ></textarea>
          <div className="invalid-feedback">
            Invalid format. Type at least two words separated by SPACE or COMMA.
          </div>
        </div>

        <div
          className="btn-group d-flex justify-content-center"
          role="group"
          aria-label="Basic example"
        >
          {/* <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              getWords();
            }}
          >
            Reload
          </button> */}
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              goToPrevious();
            }}
          >
            Previous
          </button>
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              nextValidation();
            }}
          >
            Next
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              let result = window.confirm("Really want to submit?");
              if (result) {
                submitWords();
              }
            }}
          >
            Submit
          </button>
        </div>

        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm submission
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">Really want to submit words?</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  Submit words
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="input-group my-4">
          <select
            className="custom-select"
            id="inputGroupSelect04"
            aria-label="Example select with button addon"
            onChange={e => {
              set_data_set(e.currentTarget.value);
            }}
          >
            <option value="">Select data set</option>
            <option value="words">Words</option>
            <option value="typed_words">Typed words</option>
          </select>
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => {
                getWords();
              }}
            >
              Load
            </button>
          </div>
        </div>

        <div className="row my-1">
          <div className="col-12 mb-1">
            <div className="w-100 mt-3"></div>
            <div>
              <button
                className="btn btn-link btn-sm p-0 ml-1"
                onClick={() => getWordsCount()}
              >
                Get submitted words
              </button>
              {submitted_words.length > 0 && (
                <span className="align-middle">
                  <strong> : {submitted_words}</strong>
                </span>
              )}
            </div>
            <hr />
          </div>
          <div className="col-12">
            <div className="form-group">
              <label htmlFor="word-index">Start word index</label>

              <div className="input-group mb-3">
                <input
                  type="number"
                  className="form-control"
                  id="word-index"
                  placeholder=""
                  min={0}
                  //defaultValue={startingWordIndex}
                  value={startingWordIndex}
                  onChange={e => {
                    setStartingWordIndex(e.currentTarget.value);
                  }}
                />
                {/* <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    id="button-addon2"
                  >
                    Change
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KeyboardGame;
